import { IOption } from "Dashboard/domain/IOption";
import { hrService } from "Dashboard/scenes/HumanResources/services/hr.services";
import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";

const EmployeeSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const { value, setValue } = props;
  const [valueLocal, setValueLocal] = useState<IOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const employees = await hrService.getAllEmployees();
      const op = employees.map((employee) => {
        return {
          label: employee.employeeName,
          value: employee.employeeId,
        };
      });

      setOptions(op);
      setIsLoading(false);
    }

    try {
      if (props.options) {
        setOptions(props.options);
        setIsLoading(false);
      } else {
        getData();
      }
    } catch (err) {
      console.log(err);
    }
  }, [props.options]);

  const setValueFunction = (option: IOption | undefined) => {
    if (setValue) {
      setValue(option);
    }
    setValueLocal(option);
  };

  useEffect(() => {
    if (props.defaultValue) {
      const values = options.filter((o) => o.value === props.defaultValue);
      if (values[0]) {
        setValueFunction(values[0]);
      } else {
        setValueFunction(undefined);
      }
    }
  }, [options, props.defaultValue, setValueFunction]);

  const getValue = () => {
    if (value) {
      const values = options.filter((o) => o.value === value);
      if (values[0]) {
        return values[0];
      }
    }
    return valueLocal;
  };

  const handleChange = (newValue: any, actionMeta: any) => {
    setValueFunction(newValue);
    props.onChange && props.onChange(newValue ? newValue.value : null);
  };

  return (
    <Select
      isClearable
      menuPosition="fixed"
      styles={props.customStyles}
      ref={ref}
      options={options}
      value={getValue()}
      onChange={handleChange}
      placeholder={props.placeholder ? props.placeholder : ""}
      loadingMessage={() => "Učitavanje..."}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      isDisabled={props.disabled === true}
      {...{ error: props.error }}
    />
  );
});

export default EmployeeSelect;
